export default __webpack_public_path__ + "static/media/fire-protection.c429e226.png";